import React from 'react'

export default function ScrollTop() {
    const scroll = () => {
        window.scrollTo(0,0)
    }
    return (
        <div className='scroll-btn' onClick={scroll}>
            <i className='fa-solid fa-arrow-up'></i>
        </div>
    )
}
